import React from 'react';
import PropTypes from 'prop-types';

const MobileGoalsSummaryEmptyState = ({ clientId }) => (
  <div className="mobile-goals-summary-empty-state">
    <img
      className="mobile-goals-summary-empty-state-img"
      src={`${window.ADV.settings.endpoints.imgDir}Userportal-02.png`}
      alt="safe"
    />
    <div className="mobile-goals-summary-empty-state-desc">
      Add a goal to start planning for your future.
    </div>
    <button
      type="button"
      className="mobile-goals-summary-add"
      onClick={() => {
        window.ADV.util.Router.go2('ClientEditPlan', { clientId });
      }}
    >
      Add a Goal
    </button>
  </div>
);

MobileGoalsSummaryEmptyState.propTypes = {
  clientId: PropTypes.string.isRequired,
};
export default MobileGoalsSummaryEmptyState;
